"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fusefi = void 0;
exports.fusefi = {
    router: '0xFB76e9E7d88E308aB530330eD90e84a952570319', // UniswapV2Router02
};
